import { render } from "./PropertyOffice.vue?vue&type=template&id=7b4e5460&scoped=true"
import script from "./PropertyOffice.vue?vue&type=script&lang=js"
export * from "./PropertyOffice.vue?vue&type=script&lang=js"

import "./PropertyOffice.vue?vue&type=style&index=0&id=7b4e5460&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4e5460"]])

export default __exports__